import { useState, useEffect, useMemo } from 'react'
import classNames from 'classnames'
import { SparklesIcon } from 'src/components/Icons/SparklesIcon'
import { ChevronRight } from 'src/components/Icons/ChevronRight'
import { useMuseEntryPointsConfig } from 'src/sdk/muse/useMuseEntryPointsConfig'
import { getResponsiveVisibility } from 'src/utils/getResponsiveVisibility'

type Props = {
  onClick: () => void
  variant: 'desktop' | 'mobile'
  buttonClassName?: string
}

const DEFAULT_CTA_TEXT = 'Teste nossa busca por inteligencia artificial'

export function MuseSearchCTAButton({
  onClick,
  buttonClassName,
  variant,
}: Props) {
  const config = useMuseEntryPointsConfig()
  const search = config?.search
  const [dyCtaText, setDyCtaText] = useState<string | undefined>(undefined)

  useEffect(() => {
    setDyCtaText(window?.dynamicYieldUtils?.museSearchCTA?.text)
  }, [])

  const visibilityClasses = useMemo(() => {
    return getResponsiveVisibility(search?.showOnDesktop, search?.showOnMobile)
  }, [search?.showOnDesktop, search?.showOnMobile])

  const ctaText = dyCtaText?.trim() ?? DEFAULT_CTA_TEXT

  if (!search?.enableSession) {
    return null
  }

  return (
    <button
      type="button"
      id="dy-chat-cta"
      onClick={onClick}
      className={classNames(
        'dy-chat-cta mt-md md:mt-xl hidden w-full max-w-[calc(100%-19px)] items-center justify-between rounded-round bg-gradient-to-r from-restructure-blue via-[#606CE1] to-restructure-blue py-xs pl-lg pr-xs text-restructure-white md:max-w-none',
        visibilityClasses,
        buttonClassName
      )}
      aria-label={ctaText}
      data-dy-id={`muse-search-cta-${variant}`}
    >
      <span
        id="dy-muse-widget-container-modal"
        className="flex items-center gap-xxs"
      >
        <SparklesIcon color="currentColor" full />
        <span className="font-inter text-font-size-3 font-medium text-restructure-white">
          {ctaText}
        </span>
      </span>
      <ChevronRight width={24} height={24} color="currentColor" />
    </button>
  )
}
